import { IconProps } from "@/common/contracts/icon.contracts";

export const Zap = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.7661 9.50826H12.5009L14.5046 3.65268C14.8803 2.40681 13.3775 1.41012 12.3757 2.40681L2.35728 12.3738C1.6059 13.1213 2.10682 14.4917 3.23389 14.4917H11.4991L9.4954 20.3473C9.11971 21.5932 10.6225 22.5899 11.6243 21.5932L21.6427 11.6262C22.3941 10.8787 21.8932 9.50826 20.7661 9.50826Z"
        fill="currentColor"
      />
    </svg>
  );
};
